import React, { useState, useRef, useEffect, useCallback } from 'react'
import './../../App.css';
import './Topbar.css';
import axios from '../../api/apiClient';
import { token, domain, DEV_MODE, TEST_MODE } from './../Security';
import loadingSpinner from './../../assets/loading.gif';
import { SidebarDataMenu, SidebarDataOthers, extractMenuItems } from './SidebarData';
import { useTable } from 'react-table';
import { SetAuditTrail } from './../Reports/AuditTrailReportEmployeeSetup';
import { DevModeBadge, TestModeBadge } from '../../common/Badge';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Topbar = ({ handleLogout,
  user,
  userAccess,

  employeePhoto, setEmployeePhoto,

  isHideSideMenu
}) => {
  const [isToggleShow, setIsToggelShow] = useState(false);
  const toggleRef = useRef(null);
  const buttonRef = useRef(null);

  const [imageSrc, setImageSrc] = useState("images/sample.jpg");

  const [viewApproverForm, setViewApproverForm] = useState(false);

  const [loadingRequest, setLoadingRequest] = useState(false);
  const [showChangePasswordForm, setShowChangePasswordForm] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [searchQuery, setSearchQuery] = useState('');

  const [filteredMenuList, setFilteredMenuList] = useState([]);
  const [focusedIndex, setFocusedIndex] = useState(-1);

  const [menuList, setMenuList] = useState([...extractMenuItems(SidebarDataMenu), ...extractMenuItems(SidebarDataOthers)]);
  const [loadingIds, setLoadingIds] = useState(false);

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const fetchDataEmployees = useCallback(async () => {
    const apiUrl = domain + "/api/Employee";

    try {
      const response = await axios.get(apiUrl + `/${user.employeePersonalInformationId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  }, [user]);

  const fetchTransactionIdsHR = useCallback(async () => {
    const apiUrl = domain + `/api/TransactionRequest/transaction-ids/days/${15}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  }, []);
  const fetchTransactionIdsApprover = useCallback(async () => {
    const apiUrl = domain + `/api/TransactionRequest/transaction-ids/approver/${user.employeePersonalInformationId}/days/${15}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  }, [user]);

  useEffect(() => {
    const fetchImageSrc = async () => {
      setLoadingIds(true);
      const employeeInfo = await fetchDataEmployees();

      if (employeeInfo && employeeInfo.photo) {
        const src = 'data:image/jpeg;base64,' + employeeInfo.photo;
        setImageSrc(src);
      }

      if (userAccess.description === "HR Head") {
        const _transactionIds = await fetchTransactionIdsHR();
        setMenuList(prevMenuList => {
          const newItems = _transactionIds.filter(newItem =>
            !prevMenuList.some(existingItem => existingItem.name === newItem.name)
          );

          return [...prevMenuList, ...newItems];
        });
      } else {
        const _transactionIds = await fetchTransactionIdsApprover();
        setMenuList(prevMenuList => {
          const newItems = _transactionIds.filter(newItem =>
            !prevMenuList.some(existingItem => existingItem.name === newItem.name)
          );

          return [...prevMenuList, ...newItems];
        });
      }

      setLoadingIds(false);
    };

    fetchImageSrc();
  }, [user, userAccess, fetchDataEmployees, fetchTransactionIdsHR, fetchTransactionIdsApprover, employeePhoto]);

  const toggleHandler = () => {
    if (!isToggleShow) {
      setIsToggelShow(true);
    } else {
      setIsToggelShow(false);
    }
  }
  const closeChangePasswordForm = () => {
    setShowChangePasswordForm(false);
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (toggleRef.current && !toggleRef.current.contains(event.target)) {
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
          setIsToggelShow(false);
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleInputChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    // Filter menuList based on the search query
    const filtered = menuList.filter(item =>
      item.name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredMenuList(filtered);
    setFocusedIndex(-1);
  };

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setFocusedIndex(prevIndex => (prevIndex + 1) % filteredMenuList.length);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setFocusedIndex(prevIndex => (prevIndex - 1 + filteredMenuList.length) % filteredMenuList.length);
    } else if (e.key === 'Enter' && focusedIndex >= 0) {
      window.location.pathname = filteredMenuList[focusedIndex].link;
      localStorage.setItem('searchQuery', filteredMenuList[focusedIndex].name);
    }
  }, [filteredMenuList, focusedIndex]);

  useEffect(() => {
    const inputElement = document.querySelector('.SearchBar input');
    inputElement.addEventListener('keydown', handleKeyDown);

    // Clean up the event listener on component unmount
    return () => {
      inputElement.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  const handleChangePassword = async (event) => {
    event.preventDefault();

    const apiUrl = domain + "/api/Authentication";

    const data = {
      oldPassword: oldPassword,
      newPassword: newPassword,
      username: user.username
    };

    try {
      setLoadingRequest(true);
      await axios.put(apiUrl + `/change-password`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      await SetAuditTrail({
        setupArea: "Topbar",
        actionTaken: "update",
        field: "Change Password",
        newValue: "*****",
        oldValue: "*****",
        dateSaved: new Date(),
        savedById: user.id
      });

      setShowRequestMessage(true);
      setRequestMessage("Request Success");
      setIsSuccess(true);

      // Reload table data and reset form fields
      setOldPassword("");
      setNewPassword("");
      setShowChangePasswordForm(false); // Hide the add form
    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };

  const openViewApproverForm = () => {
    setViewApproverForm(true);
  }
  const closeViewApproverForm = () => {
    setViewApproverForm(false);
  }

  const logOut = async () => {
    await SetAuditTrail({
      setupArea: "Logout Form",
      actionTaken: "logout",
      field: "Logout Form",
      newValue: `${user.employeePersonalInformationFullName}`,
      oldValue: "-",
      dateSaved: new Date(),
      savedById: user.id
    });

    handleLogout();
  }

  const handleClickSearch = (item) => {
    window.location.pathname = item.link
    localStorage.setItem('searchQuery', item.name);
  }

  //download APK
  const [showDownloadAPKAuth, setShowDownloadAPKAuth] = useState(false);
  const openDownloadAPKAuth = () => {
    setShowDownloadAPKAuth(true)
  }
  const closeDownloadAPKAuth = () => {
    setShowDownloadAPKAuth(false)
  }

  return (
    <div className="TopbarHolder">
      <div id="Topbar" className="Topbar row shadow-md">
        {/* Searchbar Sect */}
        <div className={`SearchBar ${isHideSideMenu ? "SearchBar2" : ""}`}>
          <div className="Icon"><SearchIcon /></div>
          <div className="Input">
            <input placeholder={loadingIds ? "Loading please wait...." : "Search Here"}
              value={searchQuery}
              onChange={handleInputChange}
              readOnly={loadingIds}
            />
          </div>
          {/* Display filtered suggestions */}
          {searchQuery ?
            <div>
              <ul className='topbar-searchList'>
                {filteredMenuList.map((item, index) => (
                  <li key={index} onClick={() => handleClickSearch(item)}
                    className={focusedIndex === index ? 'focused' : ''}
                  >{item.name}</li>
                ))}
              </ul>
            </div>
            :
            <></>
          }
        </div>
        {/* User Sect */}
        <div className="User row" onClick={toggleHandler} ref={buttonRef}>
          {DEV_MODE ? <div className="mr-2"><DevModeBadge /></div> : <></>}
          {TEST_MODE ? <div className="mr-2"><TestModeBadge /></div> : <></>}
          <div className="UserImg">
            <img
              src={imageSrc}
              alt=""
            >
            </img>
          </div>
          {
            isToggleShow ?
              (
                <>
                  <div id="upBtn" className="Btn">
                    <KeyboardArrowUpIcon />
                  </div>
                  <div id="dropdownList" ref={toggleRef} className="ddContent">
                    <div className='ddContent-item' onClick={() => openViewApproverForm(true)} style={{ display: "none" }}>
                      View Approver/s
                    </div>
                    <div className='ddContent-item' onClick={() => openDownloadAPKAuth()}>
                      {`Download Mobile APK`}
                    </div>
                    <div className='ddContent-item' onClick={() => setShowChangePasswordForm(true)}>
                      Change Password
                    </div>
                    <div className='ddContent-item' onClick={() => logOut()}>
                      {`Logout ${user.employeePersonalInformationFullName}`}
                    </div>
                  </div>
                </>
              )
              :
              (
                <div id="downBtn" className="Btn">
                  <KeyboardArrowDownIcon />
                </div>
              )
          }
        </div>
      </div>
      <ChangePasswordForm isOpen={showChangePasswordForm}
        onClose={closeChangePasswordForm}
        username={user.username}
        oldPassword={oldPassword}
        setOldPassword={setOldPassword}
        newPassword={newPassword}
        setNewPassword={setNewPassword}
        handleUpdate={handleChangePassword}
      >
      </ChangePasswordForm>
      <DownloadAPKAuthForm isOpen={showDownloadAPKAuth}
        onClose={closeDownloadAPKAuth}
      >
      </DownloadAPKAuthForm>
      <ViewApproverForm isOpen={viewApproverForm}
        onClose={closeViewApproverForm}
        user={user}
      >
      </ViewApproverForm>
      <GenerateMessage form={showRequestMessage}
        message={requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>
      {loadingRequest ? (
        <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: "3005" }}>
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </div>
  )
}

function ChangePasswordForm({
  isOpen,
  onClose,
  username,
  oldPassword,
  setOldPassword,
  newPassword,
  setNewPassword,
  handleUpdate }) {
  const [errorState, setErrorState] = useState(false);
  const [isPasswordNotMatch, setIsPasswordNotMatch] = useState(false);
  const [isOldPasswordNotMatch, setIsOldPasswordNotMatch] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    if (!oldPassword
      || !newPassword
      || !confirmPassword
    ) {
      setErrorState(true);
      return;
    }

    const isNotMatch = await logInToGetPassword(e);

    if (isNotMatch) {
      setIsOldPasswordNotMatch(true);
      return;
    } else {
      setIsOldPasswordNotMatch(false);
    }

    if (newPassword !== confirmPassword) {
      setIsPasswordNotMatch(true);
      return;
    }

    handleUpdate(e);
    setErrorState(false);
    setIsPasswordNotMatch(false);
    setIsOldPasswordNotMatch(false)
  };

  const logInToGetPassword = async (event) => {
    event.preventDefault();

    const data = {
      userName: username,
      password: oldPassword
    };

    const apiUrlFetch = domain + "/api/Authentication/login";

    try {
      setLoading(true);
      await axios.post(apiUrlFetch, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return false;
    } catch (error) {
      setLoading(false);
      return true;
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
    setNewPassword("")
    setOldPassword("")
    setConfirmPassword("")
    setErrorState(false);
    setIsPasswordNotMatch(false);
    setIsOldPasswordNotMatch(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Change Password</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Username</div>
                <div className="info-item-input">
                  <input
                    readOnly
                    placeholder="Password"
                    value={username}
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>
                  {
                    "Please fill up this field"
                  }
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Old Password</div>
                <div className="info-item-input">
                  <input
                    type='password'
                    placeholder="Password"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: (!oldPassword && errorState) || (isOldPasswordNotMatch) ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>
                  {
                    (isOldPasswordNotMatch) ? "Doesn't match"
                      :
                      "Please fill up this field"
                  }
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">New Password</div>
                <div className="info-item-input">
                  <input
                    type='password'
                    placeholder="Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: (!newPassword && errorState) || (isPasswordNotMatch) ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>
                  {
                    (isPasswordNotMatch) ? "Doesn't match"
                      :
                      "Please fill up this field"
                  }
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Confirm Password</div>
                <div className="info-item-input">
                  <input
                    type='password'
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: (!confirmPassword && errorState) || (isPasswordNotMatch) ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>
                  {
                    (isPasswordNotMatch) ? "Doesn't match"
                      :
                      "Please fill up this field"
                  }
                </span>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}>
                CHANGE
              </button>
            </div>
          </div>
        )}
      </div>
      {loading ? (
        <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: "3005" }}>
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </>
  );
}
function DownloadAPKAuthForm({
  isOpen,
  onClose }) {
  const [errorState, setErrorState] = useState(false);
  const [apkKey, setApkKey] = useState("");
  const [isKeyNotMatch, setIsKeyNotMatch] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!apkKey
    ) {
      setErrorState(true);
      return;
    }

    if (apkKey !== "H7EUROASIA53787") {
      setIsKeyNotMatch(true)
      return;
    }

    handleDownload();
    handleClose();
  };

  const handleDownload = () => {
    setLoading(true);

    const apkUrl = process.env.PUBLIC_URL + '/apk/HR7_Mobile_euroasia_v2.5.apk';

    // Trigger the browser download
    const link = document.createElement('a');
    link.href = apkUrl;
    link.setAttribute('download', 'HR7_Mobile_euroasia_v2.5.apk');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setLoading(false);
  };

  const handleClose = () => {
    onClose();
    setApkKey("")
    setErrorState(false);
    setIsKeyNotMatch(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Download APK Authentication</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">APK Key</div>
                <div className="info-item-input">
                  <input
                    placeholder="APK-123"
                    value={apkKey}
                    onChange={(e) => setApkKey(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: (!apkKey && errorState) || isKeyNotMatch ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>
                  {
                    (isKeyNotMatch) ? "Key doesn't match"
                      :
                      "Please fill up this field"
                  }
                </span>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={() => submit()}>
                DOWNLOAD APK
              </button>
            </div>
          </div>
        )}
      </div>
      {loading ? (
        <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: "3005" }}>
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </>
  );
}
function ViewApproverForm({ isOpen,
  onClose,
  user
}) {
  var header = [
    "Primary Approver",
    "Secondary Approver",
    "Tertiary Approver",
  ]
  var accessor = [
    "primaryApprover[0]",
    "secondaryApprover[0]",
    "tertiaryApprover[0]",
  ]

  const [loading, setLoading] = useState(false);
  const [approvers, setApprovers] = useState(false);

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/ApproverHierarchy";

    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      console.log(response.data)
      const filteredByUser = response.data.filter(data => {
        return data.employeePersonalInformationId === user.employeePersonalInformationId
      })
      setApprovers(filteredByUser); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [user]);

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [fetchData, isOpen]);

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Your Approver/s</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body loan-history-table user-template-body">
              <div className="users-table container" style={{ overflow: "unset" }}>
                <CreateTable
                  dataList={approvers ? approvers : []}
                  dataHeader={header}
                  dataAccessor={accessor}
                />
                {approvers.length > 0 ? (
                  <div></div>
                )
                  :
                  (
                    <div>
                      {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                          <img src={loadingSpinner} alt="Loading..." />
                        </div>
                      ) : (
                        <div> {/*<p>No records to display</p>*/}</div>
                      )
                      }
                    </div>
                  )}
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], editHandleClick, deleteHandleClick, employees }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const columns = React.useMemo(() =>
    dataHeader.map((header, index) => ({
      Header: header,
      accessor: dataAccessor[index]
    })),
    [dataHeader, dataAccessor]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>
                  {
                    column.render("Header")
                  }
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 &&
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          }
          {currentItems.map((row) => {
            prepareRow(row)
            return (
              <tr key={row.original.id}
                {...row.getRowProps()}
              >
                {row.cells.map((cell) => (
                  <SetInfo header={cell.render("Cell").props.column.Header}
                    _cell={cell}
                    editHandleClick={editHandleClick}
                    employees={employees} />
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <>
          <div className='table-page row' style={{ alignItems: "center", justifyContent: "end", padding: "20px 0 0 0" }}>
            <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
              &lt;&lt;
            </button>
            <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight: "5px", height: "26px" }}>
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height: "26px" }}>
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </>
      ) :
        <></>}
    </>
  )
}
function SetInfo({ header, _cell, editHandleClick, deleteHandleClick, employees }) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "") {
    return (
      <td>
        <div className="row" style={{ alignItems: "center", justifyContent: "center" }}>
          <Tooltip text="Update">
            <div style={{ padding: "0 5px" }} onClick={() => editHandleClick(data)}><ModeEditIcon /></div>
          </Tooltip>
          {deleteHandleClick ?
            <Tooltip text="Delete">
              <div style={{ padding: "0 5px" }} onClick={() => deleteHandleClick(data)}><DeleteForeverIcon /></div>
            </Tooltip>
            :
            <></>
          }
        </div>
      </td>
    )
  }

  if (header === "Employee Id") {
    const employeeInfo = employees.find(employee => employee.id === value);

    return (
      <td>
        {employeeInfo.employeeId}
      </td>
    )
  }

  if (header === "Primary Approver") {
    if (data.primaryApprover) {
      const { primaryApprover1FullName, primaryApprover2FullName, primaryApprover3FullName, primaryApprover4FullName } = data.primaryApprover;

      return (
        <td>
          {primaryApprover1FullName && (
            <>
              {primaryApprover1FullName}
              <br />
            </>
          )}
          {primaryApprover2FullName && (
            <>
              {primaryApprover2FullName}
              <br />
            </>
          )}
          {primaryApprover3FullName && (
            <>
              {primaryApprover3FullName}
              <br />
            </>
          )}
          {primaryApprover4FullName && (
            <>
              {primaryApprover4FullName}
              <br />
            </>
          )}
        </td>
      );
    } else {
      return (
        <td>
        </td>
      )
    }
  }

  if (header === "Secondary Approver") {
    if (data.secondaryApprover) {
      const {
        secondaryApprover1FullName,
        secondaryApprover2FullName,
        secondaryApprover3FullName,
        secondaryApprover4FullName
      } = data.secondaryApprover;

      return (
        <td>
          {secondaryApprover1FullName && (
            <>
              {secondaryApprover1FullName}
              <br />
            </>
          )}
          {secondaryApprover2FullName && (
            <>
              {secondaryApprover2FullName}
              <br />
            </>
          )}
          {secondaryApprover3FullName && (
            <>
              {secondaryApprover3FullName}
              <br />
            </>
          )}
          {secondaryApprover4FullName && (
            <>
              {secondaryApprover4FullName}
              <br />
            </>
          )}
        </td>
      );
    } else {
      return (
        <td>
        </td>
      )
    }
  }

  if (header === "Tertiary Approver") {
    if (data.tertiaryApprover) {
      const {
        tertiaryApprover1FullName,
        tertiaryApprover2FullName,
        tertiaryApprover3FullName,
        tertiaryApprover4FullName,
      } = data.tertiaryApprover;

      return (
        <td>
          {tertiaryApprover1FullName && (
            <>
              {tertiaryApprover1FullName}
              <br />
            </>
          )}
          {tertiaryApprover2FullName && (
            <>
              {tertiaryApprover2FullName}
              <br />
            </>
          )}
          {tertiaryApprover3FullName && (
            <>
              {tertiaryApprover3FullName}
              <br />
            </>
          )}
          {tertiaryApprover4FullName && (
            <>
              {tertiaryApprover4FullName}
              <br />
            </>
          )}
        </td>
      );
    } else {
      return (
        <td>
        </td>
      )
    }
  }

  return (
    <td {..._cell.getCellProps()}> {
      _cell.render("Cell")
    }
    </td>
  )
}
const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block', zIndex: "1" }}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      {show && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '-50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            color: 'gray',
            padding: '5px',
            borderRadius: '5px',
            pointerEvents: "none",
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};
export default Topbar
